var path = '/modules/bo/components/al-bo-preview/templates/day_range_bookings.tpl.html';
var html = "<div class=\"data-list\">\n    <table>\n        <tr ng-repeat=\"(index, option) in vm.dayRangeData[objectInformation.object.uuid]\">\n            <td>{{(index === 0) ? objectInformation.object.label : ''}}</td>\n            <td>{{option.label}} ({{option.start_date|date:'d.M.yyyy'}} - {{option.end_date|date:'d.M.yyyy'}})</td>\n        </tr>\n    </table>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/bo/components/al-bo-preview/templates/day_range_bookings.tpl.html
// module id = 2055
// module chunks = 1